document.querySelectorAll('.clp').forEach(function(root){
  var mains=root.querySelectorAll('[data-clp-main]'), thumbs=root.querySelectorAll('[data-clp-thumb]'), idx=0;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(i,dir){var n=mains.length; if(!n) return; var next=((i%n)+n)%n; if(next===idx) return;
    if(dir===undefined){dir=next>idx?1:-1;}
    idx=next; var el=null;
    mains.forEach(function(m){var on=parseInt(m.getAttribute('data-clp-main'),10)===idx; m.hidden=!on; if(on) el=m;});
    thumbs.forEach(function(x){x.classList.toggle('is-on',parseInt(x.getAttribute('data-clp-thumb'),10)===idx);});
    if(el && el.animate && !reduce){el.animate([{opacity:0,transform:'translateX('+(dir*28)+'px) scale(.985)'},{opacity:1,transform:'translateX(0) scale(1)'}],{duration:420,easing:'cubic-bezier(.22,.61,.36,1)'});}
  }
  thumbs.forEach(function(t){t.addEventListener('click',function(){show(parseInt(t.getAttribute('data-clp-thumb'),10));});});
  var gal=root.querySelector('.clp__gal'), sx=null, sy=null;
  if(gal && mains.length>1){
    mains.forEach(function(m){m.style.touchAction='pan-y'; m.setAttribute('draggable','false'); m.style.cursor='grab'; m.style.userSelect='none';});
    gal.addEventListener('pointerdown',function(e){if(e.target.closest('.clp__thumbs')) return; sx=e.clientX; sy=e.clientY;});
    gal.addEventListener('pointerup',function(e){if(sx===null) return; var dx=e.clientX-sx, dy=e.clientY-sy; sx=null;
      if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ if(dx<0){show(idx+1,1);}else{show(idx-1,-1);} }});
    gal.addEventListener('pointercancel',function(){sx=null;});
  }
  var variants=[]; try{variants=JSON.parse(root.querySelector('[data-clp-variants]').textContent);}catch(e){}
  var offers=root.querySelectorAll('[data-clp-offer]'), cur=root.querySelector('.clp__offer.is-on')||offers[0];
  function setText(sel,v){var el=root.querySelector(sel); if(el){el.textContent=v; el.hidden=!v;}}
  function setInst(o){var el=root.querySelector('[data-clp-inst]'); if(!el) return; var n=parseFloat(String(o.dataset.price||'').replace(/[^0-9.]/g,'')); if(!isNaN(n)){el.textContent='$'+(Math.round(n*100/4)/100).toFixed(2);}}
  offers.forEach(function(o){o.addEventListener('click',function(){cur=o;
    offers.forEach(function(x){var on=x===o; x.classList.toggle('is-on',on); x.setAttribute('aria-checked',on);});
    setText('[data-clp-price]',o.dataset.price); setText('[data-clp-compare]',o.dataset.compare); setText('[data-clp-save]',o.dataset.save); setInst(o);});});
  if(cur) setInst(cur);

  // PRECIO AUTOMATICO: lee el precio real del producto en Shopify (el que manda AutoDS)
  // y ajusta todas las ofertas. La oferta de 1 unidad marca el precio de referencia escrito en el editor;
  // cada oferta sube o baja (cantidad x diferencia), asi el ahorro en dolares de cada oferta se mantiene.
  function cents(s){var n=parseFloat(String(s||'').replace(/[^0-9.]/g,'')); return isNaN(n)?null:Math.round(n*100);}
  function fmt(c){return '$'+(c/100).toFixed(2);}
  function autoPrice(live){
    var ref=null;
    offers.forEach(function(o){ if(ref===null && (parseInt(o.dataset.qty||'1',10)||1)===1){ ref=cents(o.dataset.price); } });
    if(ref===null || live===null || live===ref) return;
    var d=live-ref;
    offers.forEach(function(o){
      var q=parseInt(o.dataset.qty||'1',10)||1, p=cents(o.dataset.price), c=cents(o.dataset.compare);
      if(p===null) return;
      p+=q*d; o.dataset.price=fmt(p);
      var b=o.querySelector('.clp__oprice b'); if(b) b.textContent=fmt(p);
      if(c!==null){
        c+=q*d; o.dataset.compare=fmt(c);
        var s=o.querySelector('.clp__oprice s'); if(s) s.textContent=fmt(c);
        if(c>0){
          var pct=Math.floor((c-p)*100/c);
          var fix=function(t){return String(t||'').replace(/\(\d+%\)/,'('+pct+'%)');};
          o.dataset.save=fix(o.dataset.save);
          var ch=o.querySelector('.clp__chip--save'); if(ch) ch.textContent=fix(ch.textContent);
        }
      }
    });
    if(cur){
      setText('[data-clp-price]',cur.dataset.price);
      if(cur.dataset.compare) setText('[data-clp-compare]',cur.dataset.compare);
      if(cur.dataset.save) setText('[data-clp-save]',cur.dataset.save);
      setInst(cur);
    }
  }
  var ppath=window.location.pathname.replace(/\/$/,'');
  if(offers.length && /\/products\/[^\/]+$/.test(ppath)){
    fetch(ppath+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(p){
      var vs=p.variants||[], v=vs.find(function(x){return x.available;})||vs[0];
      if(v) autoPrice(typeof v.price==='number'?v.price:cents(v.price));
    }).catch(function(){});
  }

  var atc=root.querySelector('[data-clp-atc]'); if(!atc) return;
  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)?Shopify.routes.root:'/';
  atc.addEventListener('click',function(){
    if(!cur) return;
    var wanted=(cur.dataset.variant||'').trim().toLowerCase(), v=null;
    if(wanted){v=variants.find(function(x){return x.title.trim().toLowerCase()===wanted;});}
    var qty=parseInt(cur.dataset.qty||'1',10)||1;
    if(v){qty=1;}else{v=variants.find(function(x){return x.available;})||variants[0];}
    if(!v) return;
    var items=[{id:v.id,quantity:qty}];
    // Foto propia para el carrito lateral (por ejemplo, la del hombro); propiedad oculta al cliente
    if(atc.dataset.img){items[0].properties={_img:atc.dataset.img};}
    if(atc.dataset.gift){items.push({id:parseInt(atc.dataset.gift,10),quantity:1,properties:{_regalo:'1'}});}
    atc.disabled=true;
    var go=function(){
      atc.disabled=false;
      if(window.ColanurCart){window.ColanurCart.refresh();document.dispatchEvent(new CustomEvent('cn:cart-open'));}
      else{window.location.href=base+'cart';}
    };
    // Si el regalo ya está en el carrito, no añadirlo otra vez
    fetch(base+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      if(atc.dataset.gift){var gid=parseInt(atc.dataset.gift,10);if(cart.items.some(function(x){return x.variant_id===gid&&x.properties&&x.properties._regalo;})){items=items.filter(function(x){return x.id!==gid;});}}
      return fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
    }).then(function(r){return r.json();}).then(go)
      .catch(function(){atc.disabled=false;});
  });
});
